export default __webpack_public_path__ + "static/media/community-hero.4914e614.svg";